import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarDays,
  faSearch,
  faUsers,
  faMap,
  faUser,
  faMapLocation
} from '@fortawesome/free-solid-svg-icons';
import UserContext from '../../context/UserContext';
import TourContext from '../../context/TourContext';
import styles from './BottomNavBar.module.css';

const BottomNavBar = () => {
  const { userData } = useContext(UserContext);
  const { selectedTour, selectedDate } = useContext(TourContext);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Return null if not on mobile or no user data
  const isMobile = window.innerWidth <= 768;
  if (!isMobile || !userData) return null;
  
  // Define navigation items based on user type
  const getNavItems = () => {
    // Common items for all user types
    const commonItems = [
      {
        label: 'Dates',
        icon: faCalendarDays,
        path: '/dates',
        onClick: () => navigate('/dates')
      },
      {
        label: 'Search',
        icon: faSearch,
        path: '/search',
        onClick: () => navigate('/search')
      },
      {
        label: 'Profile',
        icon: faUser,
        path: `/${userData.userName}`,
        onClick: () => navigate(`/${userData.userName}`)
      }
    ];
    
    // User type specific items
    switch (userData.userType) {
      case 'Manager':
      case 'Artist':
      case 'Crew':
        return [
          commonItems[0], // Dates
          commonItems[1], // Search
          {
            label: 'Crew',
            icon: faUsers,
            path: '/crew',
            onClick: () => navigate('/crew')
          },
          {
            label: 'Routes',
            icon: faMapLocation,
            path: '/routes-map',
            onClick: () => navigate('/routes-map')
          },
          commonItems[2] // Profile
        ];
      case 'Vendor':
        return [
          commonItems[0], // Dates
          commonItems[1], // Search
          {
            label: 'Staff',
            icon: faUsers, // Replace with appropriate icon
            path: '/staff',
            onClick: () => navigate('/staff')
          },
          {
            label: 'Inventory',
            icon: faCalendarDays, // Replace with appropriate icon
            path: '/inventory',
            onClick: () => navigate('/inventory')
          },
          commonItems[2] // Profile
        ];
      case 'Staff':
        return [
        commonItems[0], // Dates
        commonItems[1], // Search
        {
          label: 'Vendors',
          icon: faUsers,
          path: '/associated-vendors',
          onClick: () => navigate('/associated-vendors')
        },
        commonItems[2] // Profile
      ];
      case 'Organization':
        return [
          commonItems[0], // Dates
          commonItems[1], // Search
          {
            label: 'Managers',
            icon: faUsers,
            path: '/organization-managers',
            onClick: () => navigate('/organization-managers')
          },
          {
            label: 'Acts',
            icon: faUsers, // Replace with appropriate icon
            path: '/managing-acts',
            onClick: () => navigate('/managing-acts')
          },
          commonItems[2] // Profile
        ];
      default:
        return commonItems;
    }
  };
  
  const navItems = getNavItems();
  
  // Check if a nav item is active
  const isActive = (path) => {
    if (path === '/dates' && location.pathname.includes('/dates')) {
      return true;
    }
    if (path === '/route' && location.pathname.includes('/route')) {
      return true;
    }
    if (path === '/search' && location.pathname === '/search') {
      return true;
    }
    if (path === '/crew' && location.pathname === '/crew') {
      return true;
    }
    return location.pathname === path || 
      // For profile path
      (path.startsWith('/' + userData.userName) && 
       location.pathname.startsWith('/' + userData.userName));
  };

  return (
    <div className={styles.bottomNav}>
      {navItems.map((item) => (
        <button
          key={item.label}
          className={`${styles.navItem} ${isActive(item.path) ? styles.active : ''}`}
          onClick={item.onClick}
        >
          <FontAwesomeIcon icon={item.icon} className={styles.navIcon} />
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default BottomNavBar;